import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import TargetingOptions from './TargetingOptions';
import './BlastsCSS/DialogStyles.css';

export default function TargetingDemographicsDialog({ open, onClose, onConfirm, includeMembershipQuestion }) {
    const [selectedGenders, setSelectedGenders] = useState(['all']);
    const [selectedAgeRange, setSelectedAgeRange] = useState('all');
    const [membershipFilter, setMembershipFilter] = useState('all');

    const handleConfirm = () => {
        // If 'all' is selected or no selections, send all genders
        const gendersToSend = selectedGenders.includes('all') || selectedGenders.length === 0 
            ? ['all'] 
            : selectedGenders;

        onConfirm({
            selectedGenders: gendersToSend,
            selectedAgeRange,
            membershipStatus: membershipFilter
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Typography component="div" className="dialog-title inter-custom">
                    Target Your Blast
                </Typography>
            </DialogTitle>
            <DialogContent className="dialog-content">
                <Box>
                    <Typography className="dialog-message dialog-message-first">
                        Select your targeting criteria
                    </Typography>

                    <TargetingOptions
                        selectedGenders={selectedGenders}
                        setSelectedGenders={setSelectedGenders}
                        selectedAgeRange={selectedAgeRange}
                        setSelectedAgeRange={setSelectedAgeRange}
                        membershipFilter={membershipFilter}
                        setMembershipFilter={setMembershipFilter}
                        includeMembershipQuestion={includeMembershipQuestion}
                    />
                </Box>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <Button 
                    onClick={onClose}
                    className="dialog-button dialog-button-secondary inter-custom"
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleConfirm}
                    className="dialog-button dialog-button-primary inter-custom"
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}